import { Injectable } from '@angular/core';

import { apiName } from "./data.service";
import { RestService } from "../../../core/services/rest.service";
import { Cerca } from "./cerca.model";

@Injectable()
export class CercaApiService {

    constructor(
        private _restService: RestService
    ) { }

    onPost(object: Cerca, done: any) {
        this._restService.onPost(apiName, object, done);
    }

    onPut(object: Cerca, done: any) {
        this._restService.onPut(apiName, object, done);
    }

    onDelete(objectId: number, done: any) {
        this._restService.onDelete(apiName, objectId, done);
    }

    onGetAll(done: any) {
        let filter: any = {"order":"nome"};
        this._restService.onGetPost(apiName, filter, done);
    }

    onGetById(objectId: number, done: any) {
        let filter: any = {};
        this._restService.onGetPostId(apiName, objectId, filter, done);
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/rastreamentos/cercas/shared/cerca-api.service.ts
 **/